module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      menu: _vm.menuIsOpen
    },
    attrs: {
      "id": "topbar"
    }
  }, [_c('a', {
    staticClass: "header_logo medium h4 c-dark",
    attrs: {
      "href": '/' + _vm.locale
    }
  }, [_c('span', {
    staticClass: "c-accent"
  }, [_vm._v("MY.")]), _vm._v("KRIPTONITE\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "controls_btn"
  }, [_c('burger', {
    attrs: {
      "close": _vm.menuIsOpen
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenu($event)
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "controls_btn",
    on: {
      "click": _vm.showTooltips
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/tips.svg"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "controls_btn",
    on: {
      "click": _vm.reloadProject
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/restart.svg"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "controls_btn email_btn",
    class: {
      animation: _vm.email_animating
    },
    attrs: {
      "href": 'mailto:' + _vm.email,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/mail.svg"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dcacfc3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/partials/Topbar.vue
// module id = 620
// module chunks = 0